// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3MYMC","similarPeopleContainer":"styles_similarPeopleContainer__Xx6tl","emptyData":"styles_emptyData__Rtrta"};